/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} B2b_Feat_1_DescInputs */

const en_b2b_feat_1_desc = /** @type {(inputs: B2b_Feat_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Point your existing domain to our architecture. Maintain 100% of your brand equity while utilizing our checkout engine.`)
};

const es_b2b_feat_1_desc = /** @type {(inputs: B2b_Feat_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Apunta tu dominio existente a nuestra arquitectura. Mantén el 100% de tu capital de marca.`)
};

const fr_b2b_feat_1_desc = /** @type {(inputs: B2b_Feat_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Faites pointer votre domaine existant vers notre architecture. Maintenez 100 % de votre capital de marque tout en utilisant notre moteur de paiement.`)
};

const de_b2b_feat_1_desc = /** @type {(inputs: B2b_Feat_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Leite deine bestehende Domain auf unsere Architektur. Behalte 100% deines Markenwerts.`)
};

const id_b2b_feat_1_desc = /** @type {(inputs: B2b_Feat_1_DescInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Arahkan domain Anda saat ini ke arsitektur kami. Pertahankan 100% nilai merek Anda sambil memanfaatkan mesin checkout kami.`)
};

/** @type {(inputs: B2b_Feat_1_DescInputs) => LocalizedString} */
const ja_b2b_feat_1_desc = en_b2b_feat_1_desc;

/** @type {(inputs: B2b_Feat_1_DescInputs) => LocalizedString} */
const zh_b2b_feat_1_desc = en_b2b_feat_1_desc;

/** @type {(inputs: B2b_Feat_1_DescInputs) => LocalizedString} */
const ar_b2b_feat_1_desc = en_b2b_feat_1_desc;

/** @type {(inputs: B2b_Feat_1_DescInputs) => LocalizedString} */
const it_b2b_feat_1_desc = en_b2b_feat_1_desc;

/** @type {(inputs: B2b_Feat_1_DescInputs) => LocalizedString} */
const ru_b2b_feat_1_desc = en_b2b_feat_1_desc;

/** @type {(inputs: B2b_Feat_1_DescInputs) => LocalizedString} */
const pt_b2b_feat_1_desc = en_b2b_feat_1_desc;

/** @type {(inputs: B2b_Feat_1_DescInputs) => LocalizedString} */
const ko_b2b_feat_1_desc = en_b2b_feat_1_desc;

/**
* | output |
* | --- |
* | "Point your existing domain to our architecture. Maintain 100% of your brand equity while utilizing our checkout engine." |
*
* @param {B2b_Feat_1_DescInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const b2b_feat_1_desc = /** @type {((inputs?: B2b_Feat_1_DescInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<B2b_Feat_1_DescInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_b2b_feat_1_desc(inputs)
	if (locale === "es") return es_b2b_feat_1_desc(inputs)
	if (locale === "fr") return fr_b2b_feat_1_desc(inputs)
	if (locale === "de") return de_b2b_feat_1_desc(inputs)
	if (locale === "ja") return ja_b2b_feat_1_desc(inputs)
	if (locale === "zh") return zh_b2b_feat_1_desc(inputs)
	if (locale === "ar") return ar_b2b_feat_1_desc(inputs)
	if (locale === "id") return id_b2b_feat_1_desc(inputs)
	if (locale === "it") return it_b2b_feat_1_desc(inputs)
	if (locale === "ru") return ru_b2b_feat_1_desc(inputs)
	if (locale === "pt") return pt_b2b_feat_1_desc(inputs)
	return ko_b2b_feat_1_desc(inputs)
});